import type { KeyboardShortcutHintProps } from "@/components/KeyboardShortcutHint";

export type KeyboardShortcutEntry = {
  description: string;
  hints: KeyboardShortcutHintProps[];
};

type BuildKeyboardShortcutEntriesInput = {
  showGoNav: boolean;
  addMenuItems: { label: string; chordKey: string }[];
  canViewMcpPlayground: boolean;
};

export function buildKeyboardShortcutEntries({
  showGoNav,
  addMenuItems,
  canViewMcpPlayground
}: BuildKeyboardShortcutEntriesInput): KeyboardShortcutEntry[] {
  const entries: KeyboardShortcutEntry[] = [
    {
      description: "Find",
      hints: [{ keyLabel: "k", showModifier: true }]
    },
    ...addMenuItems.map((item) => ({
      description: item.label,
      hints: [
        { keyLabel: "a", showModifier: false },
        { keyLabel: item.chordKey, showModifier: false }
      ]
    }))
  ];

  if (showGoNav) {
    entries.push({
      description: "Go to a main section",
      hints: [
        { keyLabel: "g", showModifier: false },
        { keyLabel: "Tab", showModifier: false }
      ]
    });
  }

  entries.push({
    description: "Focus page table search",
    hints: [{ keyLabel: "/", showModifier: false }]
  });

  if (canViewMcpPlayground) {
    entries.push({
      description: "Chat with Member 360",
      hints: [{ keyLabel: "?", showModifier: false }]
    });
  }

  entries.push({
    description: "Keyboard Shortcuts",
    hints: [{ keyLabel: "?", showModifier: true, implicitShift: true }]
  });

  return entries;
}
